import * as yup from 'yup';
import { VALIDATION_MESSAGE } from '../constants/Constants';



const ResetPasswordValidation: any = yup.object().shape({
    password: yup.string().required(VALIDATION_MESSAGE.Field("password"))
        .min(8, VALIDATION_MESSAGE?.MinLength('Password', 8))
        .max(15, VALIDATION_MESSAGE?.MaxLength('Password', 15))
        .matches(/^\S*$/, VALIDATION_MESSAGE?.NO_SPACE_ALLOWED)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/, VALIDATION_MESSAGE?.PASSWORD_UPPER_CASE),

        confirm_password: yup.string()
        .required(VALIDATION_MESSAGE.Field("confirm password"))
        .oneOf([yup.ref('password')], VALIDATION_MESSAGE?.PASSWORD_CPWD_NOT_MATCHED)
        .min(8, VALIDATION_MESSAGE?.MinLength('confirm password', 8))
        .max(15, VALIDATION_MESSAGE?.MaxLength('confirm password', 15))
        .matches(/^\S*$/, VALIDATION_MESSAGE?.NO_SPACE_ALLOWED)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/, VALIDATION_MESSAGE?.PASSWORD_UPPER_CASE),
});

export default ResetPasswordValidation;

